export default __webpack_public_path__ + "static/media/img-user.f76af269.svg";